import antdId from "antd/lib/locale-provider/id_ID";
import appLocaleData from "react-intl/locale-data/id";
import enMessages from "../locales/en_US.json";
import idMessages from "../locales/id_ID.json";

const IdLang = {
  messages: {
    ...enMessages,
    ...idMessages
  },
  antd: antdId,
  locale: 'id',
  data: appLocaleData
};
export default IdLang;
